import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface INotificationsSlice {
	readNotifications: Record<string, boolean>;
}

const initialState: INotificationsSlice = {
	readNotifications: {},
};

export const notificationsSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setReadNotifications: (state, action: PayloadAction<number[]>) => {
			action.payload.forEach((id) => {
				state.readNotifications[id] = true;
			});
		},

		clearReadNotifications: (state) => {
			state.readNotifications = {};
		},
	},
});

export default notificationsSlice.reducer;
export const { setReadNotifications, clearReadNotifications } = notificationsSlice.actions;
